import * as React from 'react';

import { cn, Col, ContentCard, Footer } from '@rematter/ui-web';

type Props = {
  className?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  sidebar?: React.ReactNode;
  variant?: 'default' | 'embedded';
};

//
// ⚛️ ⚛️ ⚛️ FINANCE DETAIL LAYOUT ⚛️ ⚛️ ⚛️
//
export const FinanceDetailLayout: React.FC<Props> = ({
  className,
  children,
  footer,
  sidebar,
  variant = 'default',
}) => (
  <Col
    className={cn(
      '@FinanceDetailLayout',
      'h-full overflow-hidden',
      variant !== 'embedded' && 'p-5',
      className,
    )}
  >
    <ContentCard
      className={cn(
        'flex min-h-0 flex-1 flex-col overflow-hidden p-0',
        variant === 'embedded' && 'rounded-none border-none',
      )}
    >
      {sidebar && (
        <div className="flex min-h-0 flex-1 overflow-y-auto">
          <div className="min-h-0 flex-1 overflow-y-auto px-7.5 py-6">
            {children}
          </div>
          {sidebar}
        </div>
      )}
      {!sidebar && (
        <div className="min-h-0 flex-1 overflow-y-auto px-7.5 py-6">
          {children}
        </div>
      )}
      {footer && <Footer className="bg-white px-7.5 py-4">{footer}</Footer>}
    </ContentCard>
  </Col>
);
